<template lang="pug">
    .cell-action-wrapper.overflow-initial
        .cell-content.actions
            ActionsMenu(:actions="actions")
</template>

<script>
import { mapMutations, mapActions } from 'vuex'
import ActionsMenu from '@/components/common/ActionsMenu'

export default {
    name: 'CellConfigAction',
    props: {
        clickOnCell: {
            type: Function,
            default: () => {}
        },
        data: {
            type: [Function, Array, String, Number],
            default: null
        },
        type: {
            type: String,
            default: ''
        },
        fullData: {
            type: Object,
            default: () => ({})
        }
    },

    components: { ActionsMenu },

    data() {
        return {
            actions: [
                {
                    label: 'delete',
                    action: async () => {
                        await this.deleteConfigHandler()
                    }
                }
            ]
        }
    },
    methods: {
        ...mapActions('data/transfer', ['retrieveAccountsDspActiveTransfers']),
        ...mapMutations('ui/dsp', ['setDisplayModal', 'setDeletedConfig']),
        deleteConfigHandler() {
            this.retrieveAccountsDspActiveTransfers({ accounts_dsp_id: this.fullData.id }).then(() => {
                this.setDisplayModal({ item: 'confirmation', display: true })
                this.setDeletedConfig({ id: this.fullData.id })
            })
        }
    }
}
</script>
